import React, { SVGProps } from "react";
const Otto = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={53}
    height={65}
    viewBox="0 0 53 65"
    fill="none"
    {...props}
  >
    <path
      fill="#F8F4F4"
      d="M46.312 58.093c-1.543-13.683-6.197-17.51-6.197-17.51l-30.007-1.179s-6.444 2.95-7.522 19.719l-.073 1.05 44.042-.352-.243-1.728Z"
    />
    <path
      fill="#C9DDE7"
      d="M40.21 41.596s1.327.058.63 1.575-5.728 4.764-6.774 5.314c-1.046.55-4.537 1.758-6.241 3.072-1.711 1.314-3.892 2.52-4.935 1.962-1.043-.557-4.018-2.992-4.8-3.24-.783-.25-7.185-3.746-7.56-5.126-.38-1.38-2.389-4.094-2.042-4.441.347-.348 2.918-2.155 2.918-2.155l28.329 1.961.489 1.079-.013-.001Z"
    />
    <path
      fill="#F8F4F4"
      d="M11.85 23.645c-1.785-3.912-.928-9.381-1.034-11.343-.105-1.963-1.197-.964-4.414-.235-3.217.729-4.07-5.205 1.967-8.964 6.037-3.758 8.367 3.636 8.367 3.636 9.56-8.99 19.722.745 19.722.745s4.191-7.968 9.176-1.133c3.776 6.042.498 7.636-1.19 6.867-1.973-1.212-3.714-1.215-3.736-.904-.021.31.156 10.249-1.252 12.315 0 0-1.324-.683-1.784-.445-.46.238-.33-1.052-.7-.766-.37.285.03.454-.836.908-.865.454-.96-.305-1.74.256-.778.562-.844 1.32-1.388 1.019-.544-.301.102-1.074-.832-.413-.933.66-.838 1.227-2.292 1.157-1.454-.07-9.548.203-10.002-.515-.455-.711-1.71-2.484-2.311-1.966-.6.517-.768.403-.94.075-.172-.327-.923-.162-1.844-.563-.085-.034-1.141-.407-1.716-.067-.575.34-1.226.323-1.226.323l.006.013Z"
    />
    <path
      fill="#28BBB2"
      d="M10.182 38.688s-.527 2.306 1.159 4.245c1.686 1.94 6.155 5.03 10.088 7.69 1.58 1.234 2.478 1.977 4.805.436 2.327-1.541 3.197-2.746 5.96-3.778 2.764-1.032 7.867-3.28 8.006-7.303.14-4.022-9.221-3.317-9.221-3.317l-19.526-.021-1.27 2.047Z"
    />
    <path
      fill="#0EA495"
      d="M10.66 39.674s1.972 2.381 3.294 2.698c1.322.316 1.818.045 2.264.394.447.35 2.53 1.122 4.067.662 1.537-.461 1.827.4 2.38.477.552.075 2.935.408 5.165-.359 2.23-.766 2.473-.29 3.27-.443.796-.152 2.136-1.157 3.348-1.008 1.213.148 3.924-.865 4.717-1.36.794-.494 1.58-2.252 1.177-3.025-.404-.773-27.88-3.032-27.88-3.032l-2.11 1.652.3 3.356.007-.012Z"
    />
    <path
      stroke="#4D4D4D"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.556}
      d="M10.182 38.688s-.527 2.306 1.159 4.245c1.686 1.94 6.155 5.03 10.088 7.69 1.58 1.234 2.478 1.977 4.805.436 2.327-1.541 3.197-2.746 5.96-3.778 2.764-1.032 7.867-3.28 8.006-7.303.14-4.022-9.221-3.317-9.221-3.317l-19.526-.021-1.27 2.047ZM39.47 24.618c1.408-2.058 1.231-12 1.253-12.31.022-.31 1.763-.315 3.735.904 1.688.761 4.959-.832 1.19-6.866-4.984-6.825-9.174 1.134-9.174 1.134s-10.16-9.73-19.719-.744c0 0-2.336-7.392-8.365-3.634-6.035 3.757-5.184 9.689-1.967 8.96 3.217-.729 4.315-1.726 4.414.235.099 1.96-.752 7.428 1.033 11.34"
    />
    <path
      fill="#fff"
      stroke="#4D4D4D"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.556}
      d="M21.263 16.163c1.839.064.94-1.345.94-1.345 1.295-1.586-.566-2.105-.566-2.105s.469-1.62-1.101-1.195c0 0-.31-1.55-1.975.547 0 0-1.53-1.605-2.954-.184 0 0-2.064-.497-1.565.352 0 0-1.97-.096-1.124 1.369 0 0-1.491.943-.092 1.614 0 0-.592 1.356.747 1.256 0 0 .031 1.585 1.578.334 0 0 .557 1.087 1.836-.188 0 0 .78 1.559 2.082-.047 0 0 1.308 1.407 2.207-.407l-.013-.002ZM29.157 17.025c-1.834.075-1.01-1.34-1.01-1.34-1.376-1.577.463-2.104.463-2.104s-.547-1.617 1.045-1.202c0 0 .229-1.554 2 .537 0 0 1.45-1.61 2.945-.201 0 0 2.04-.51 1.584.34 0 0 1.964-.11 1.19 1.356 0 0 1.535.934.17 1.61 0 0 .66 1.347-.679 1.26 0 0 .052 1.586-1.564.346 0 0-.506 1.09-1.843-.178 0 0-.707 1.558-2.082-.033 0 0-1.235 1.41-2.225-.399l.006.008Z"
    />
    <path
      stroke="#4D4D4D"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.556}
      d="M19.106 20.84c-.118-.708-.948-3.87-2.392-.627M34.371 21.216c-.292-.655-1.88-3.494-2.443.023"
    />
    <path
      fill="#fff"
      stroke="#4D4D4D"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.556}
      d="M30.513 26.51s1.404-2.503 2.24-.696c0 0 2.255-2.56 2.808-.745 0 0 1.553-3.108 2.129-.746 0 0 1.975-1.145 1.953.526 0 0 2.024-.503 1.315.715 0 0 2.435.357 1.587 1.921 0 0 2.809 1.366 1.084 1.916 0 0 2.16 2.656.025 3.017 0 0 .856 3.064-.824 2.476 0 0 .517 3.678-1.371 2.22 0 0-2.153 6.694-3.293 1.725 0 0-.826 1.626-1.443-.128 0 0-1.104 4.761-2.41.136 0 0-.136 2.358-1.416 1.135 0 0-1.33 2.896-2.185.682 0 0-1.154 2.97-1.967-.322 0 0-1.556 3.613-2.746.724 0 0-1.76 3.946-3.802-.339 0 0-.491 1.948-2.27-.229 0 0-.76 4.56-3.963-.62 0 0-.692 3.1-1.866.358 0 0-1.346 1.46-2.666-1.791 0 0-1.115 1.54-1.757-1.212 0 0-1.59 1.995-1.952-.938 0 0-1.474 2.444-.967-1.846 0 0-2.6 1.142-1.134-2.445 0 0-1.698-.71.595-2.171 0 0-2.954-1.027.715-2.658 0 0-2.163-1.847 1.338-2.603 0 0-1.577-2.458 3.707-.433 0 0 .798-1.715 2.533-.564 0 0 1.103-1.369 2.193.84 0 0 1.92-1.614 3.122 1.215l10.674.886.014-.005Z"
    />
    <path
      fill="#4D4D4D"
      stroke="#4D4D4D"
      strokeMiterlimit={10}
      strokeWidth={0.556}
      d="M25.216 25.203s3.366-2.37 4.885-.427c.525.672.575 1.606.207 2.358-.564 1.139-1.843 2.606-3.837 3.052-2.924.65-6.242-.677-6.685-2.916-.11-1.419.13-4.003 5.423-2.067h.007Z"
    />
    <path
      fill="#fff"
      d="M20.84 26.197c.25-.597 1.575-1.418 1.851-.247.277 1.17-.236 1.95-.961 2.006-.509.034-1.262-.86-.883-1.758l-.007-.001Z"
    />
    <path
      stroke="#4D4D4D"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.556}
      d="m25.838 30.307.131 3.906M23.105 32.904s1.311 2.165 4.328 1.017"
    />
    <path
      fill="#28BBB2"
      d="M40.978 40.446s8.072-11.84 9.244-7.986c.372 1.589-2.238 7.801-9.244 7.986Z"
    />
    <path
      stroke="#0EA495"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.556}
      d="M49.79 31.81s-.876-.446-8.812 8.638"
    />
    <path
      stroke="#4D4D4D"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.556}
      d="M40.978 40.446s8.072-11.84 9.244-7.986c.372 1.589-2.238 7.801-9.244 7.986v0Z"
    />
    <path
      fill="#fff"
      d="M28.114 57.572c-1.602-1.31.055-2.596.055-2.596-.126-2.117 2.002-1.513 2.002-1.513.3-2.223 2.792-1.321 2.792-1.321.719-1.86 2.73-1.214 2.73-1.214.965-1.521 2.866-.15 2.866-.15 1.903-.846 2.214 2.015 2.214 2.015 1.862-.737 1.355 1.963 1.355 1.963 1.664.006.904 2.856.904 2.856s1.077.812-.185 1.432c0 0-11.556 1.133-15.22.026-.429.477-1.682-1.497.487-1.505v.007Z"
    />
    <path
      stroke="#4D4D4D"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.556}
      d="M43.025 57.596s.759-2.847-.904-2.852c0 0 .514-2.698-1.354-1.962 0 0-.31-2.857-2.213-2.012 0 0-1.9-1.37-2.865.15 0 0-2.002-.652-2.728 1.213 0 0-2.491-.894-2.79 1.32 0 0-2.127-.603-2.001 1.511 0 0-1.663 1.277-.056 2.594"
    />
    <path
      fill="#fff"
      d="M22.33 58.302c1.487-1.367-.282-2.587-.282-2.587-.059-2.116-2.132-1.444-2.132-1.444-.49-2.208-2.9-1.23-2.9-1.23-.878-1.833-2.826-1.123-2.826-1.123-1.091-1.482-2.872-.056-2.872-.056-1.967-.788-2.034 2.078-2.034 2.078-1.921-.671-1.18 2.003-1.18 2.003-1.661.061-.66 2.878-.66 2.878s-1.008.842.306 1.424c0 0 11.635.753 15.2-.477.474.46 1.554-1.547-.62-1.486v.02Z"
    />
    <path
      stroke="#4D4D4D"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.556}
      d="M7.445 58.825s-1-2.82.66-2.875c0 0-.74-2.672 1.18-2.002 0 0 .067-2.864 2.033-2.077 0 0 1.78-1.425 2.871.056 0 0 1.947-.716 2.825 1.123 0 0 2.416-.978 2.899 1.228 0 0 2.072-.671 2.13 1.443 0 0 1.768 1.225.282 2.584M46.307 58.047c-1.581-13.744-6.288-17.598-6.288-17.598M10.208 39.425S3.684 42.382 2.614 59.24"
    />
  </svg>
);
export default Otto;
